import { render, staticRenderFns } from "./DetailUnitSelector.vue?vue&type=template&id=1d4d6040&scoped=true&"
import script from "./DetailUnitSelector.vue?vue&type=script&lang=ts&"
export * from "./DetailUnitSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DetailUnitSelector.vue?vue&type=style&index=0&id=1d4d6040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4d6040",
  null
  
)

export default component.exports